import { getQaSelector } from '../../../utils/common'

import { QA_NAME_CALENDAR_RAIL } from './CalendarRail.constants'
import { CalendarRailBuilding } from './CalendarRailBuilding'
import { CalendarRailSources } from './CalendarRailSources'
import { CalendarRailView } from './CalendarRailView'
import { CalendarRailWho } from './CalendarRailWho'

import * as styles from './CalendarRail.module.css'

function CalendarRail({ preferences, onChange }) {
  return (
    <aside
      {...getQaSelector({ value: QA_NAME_CALENDAR_RAIL })}
      className={styles.CalendarRail}
    >
      <CalendarRailWho />
      <CalendarRailBuilding
        building={preferences.building}
        onChange={onChange}
      />
      <CalendarRailSources sources={preferences.sources} onChange={onChange} />
      <CalendarRailView
        includeCancelledAppointments={
          preferences.include_cancelled_appointments
        }
        includeDoneTasks={preferences.include_done_tasks}
        onChange={onChange}
      />
    </aside>
  )
}

export default CalendarRail
